import i18n from '@/locale/index'

export default [
  {
    path: '/cityMap',
    name: 'cityMap',
    component: () => import('../../views/cityMap/index.vue'),
    meta: {
      pageKey: 'Mycity_home'
    }
  }
]
